const getReadTimeLabel = (readTime: number) => {
  if (readTime < 1) {
    return 'less than a minute read';
  }
  if (readTime === 1) {
    return '1 min read';
  }
  if (readTime < 60) {
    return `${readTime} mins read`;
  }
  if (readTime === 60) {
    return '1 hour read';
  }
  const hours = Math.floor(readTime / 60);
  const minutes = readTime % 60;
  if (minutes === 0) {
    return `${hours} hours read`;
  }
  return `${hours} hours ${minutes} mins read`;
};

export default getReadTimeLabel;
